// Accordion (blocco generico): apertura UNA ALLA VOLTA. L'altezza la anima il CSS
// (grid-template-rows 0fr->1fr); qui solo apri/chiudi + stato aria. Aprendo una voce
// si chiudono le altre dello stesso accordion.
const accordion = () => {
  document.querySelectorAll(".accordion").forEach((acc) => {
    const headers = acc.querySelectorAll(".accordion__header");

    headers.forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".accordion__item");
        if (!item) return;
        const willOpen = !item.classList.contains("is-open");

        // Single-open: chiudi le altre voci aperte.
        acc.querySelectorAll(".accordion__item.is-open").forEach((other) => {
          if (other === item) return;
          other.classList.remove("is-open");
          const h = other.querySelector(".accordion__header");
          if (h) h.setAttribute("aria-expanded", "false");
        });

        item.classList.toggle("is-open", willOpen);
        btn.setAttribute("aria-expanded", String(willOpen));
      });
    });
  });
};

export default accordion;
